import { MTableEditField } from '@material-table/core';
import React from 'react';

export default descriptorTypes => [
  {
    title: 'ID',
    field: 'id',
    editable: 'never',
    width: 100,
  },
  {
    title: 'Id Tipo',
    field: 'descriptor_type_id',
    lookup: descriptorTypes,
    initialEditValue: Object.keys(descriptorTypes)[0],
    width: 100,
  },
  {
    title: 'Ordem',
    field: 'order',
    width: 100,
  },
  {
    title: 'Codigo',
    field: 'code',
    width: 100,
  },
  {
    title: 'Filtro LCS',
    field: 'filter_lcs',
    width: 100,
  },
  {
    title: 'Descrição',
    field: 'description',
    width: 400,
    editComponent: (props) => <MTableEditField fullWidth {...props} multiline/>,
  }
];
